module.exports = __webpack_public_path__ + "img/lns-button.cb4b572e.png";